export const environment = {
  production: false,
  appUrl: 'https://dev.edutrip.my',
  appVersion: '1.0.0',
  api: {
    url: 'https://api.gogokids.my/api/',
  }
};